import React, {Component} from 'react';
import {Button, Form, Grid, Header, Icon, Image, Modal, Popup, Segment,Divider,Message,Label} from 'semantic-ui-react';
import ReportContainer from "../../containers/report_container";
import 'react-dropzone-component/styles/filepicker.css';
import 'dropzone/dist/min/dropzone.min.css';
import Loader from "../universal/loader";
import { DropzoneComponent } from 'react-dropzone-component';
import {uploadAdditionalImage,getAdditionalInspectionImages,deleteAdditionalImage} from "../../data/inspection_api";
import * as unavailable from "../../assets/photo_unavailable.jpg";

const uuidv1 = require('uuid/v1');

class AdditionalRoomPhotos extends Component {

    constructor(props) {
        super(props);
        this.state = {
            ciImageEdit: undefined,
            coImageEdit: undefined,
            attachments: [],
            additional_images:[],
            loading:true,
            errorMsg:undefined,
            imgErrorMsg:undefined,
            failedAddUploads: [],
            show:false,
            imgNumber:undefined,
            totalImgNumber:undefined,
            uploading:false
        }
    }

    componentWillMount() {
        // this.getAdditionalImages()
    }
    
    getAdditionalImages = async () => {
        this.setState({show:true,loading:true})
            const response = await getAdditionalInspectionImages(this.props.inspectionId)
            this.setState({ additional_images: response,loading:false })
        
    }

    retryImageUpload = async ()  =>{
        let addImages = [...this.state.failedAddUploads]
        this.setState({loading:false, uploading:true,imgErrorMsg:undefined,imgNumber:undefined,totalImgNumber:undefined,failedAddUploads:[]})
        if (addImages.length > 0) {
            for (let i = 0; i < addImages.length; i++) {
                this.setState({imgNumber:i,totalImgNumber:addImages.length})
                let addResponse = undefined
                addResponse = await uploadAdditionalImage(addImages[i]);
                this.addSuccessFn(addResponse, addImages[i])
            }
            this.completeCallBack();
        
         } else {
            this.completeCallBack();
        }


    }


    uploadAdditionalRoomImages = async () => {
        this.setState({errorMsg:undefined,loading:false,uploading:true});
                        if(this.state.attachments) {
                            let addResponse = undefined
                            for (let i = 0; i < this.state.attachments.length; i++) {
                                this.setState({imgNumber:i, totalImgNumber:this.state.attachments.length})
                                if (this.state.attachments[i].status === "queued") {
                                const formData = new FormData();
                                formData.append("id", this.state.attachments[i].upload.uuid);
                                formData.append("file", this.state.attachments[i]);
                                formData.append("inspection_id",this.props.inspectionId);
                                formData.append("image_type",this.props.roomClientId);
                                addResponse = await uploadAdditionalImage(formData);
                                this.addSuccessFn(addResponse, formData)
                            }
                                
                            }
                            this.setState({attachments:[],uploading:false})
                            this.getAdditionalImages()
                        }
                    }
                 

    successFn = (response, image) => {
        if (!response.success) {
            let error = undefined
            let err = response.statusMessage
            if (err.response) {
                error = err.response.data.error || "An error occurred on the server.";
            } else if (err.request) {
                error = "Network error: Please check your internet connection.";
            } else {
                error = err.message || "An unknown error occurred.";
            }
            this.setState({ imgErrorMsg:error, failedUploads:[...this.state.failedUploads, image]})
        }
    };
    addSuccessFn = (response, image) => {
        if (!response.success) {
            let error = undefined
            let err = response.error
            if (err.response) {
                error = err.response.data.error || "An error occurred on the server.";
            } else if (err.request) {
                error = "Network error: Please check your internet connection.";
            } else {
                error = err.message || "An unknown error occurred.";
            }
            this.setState({ imgErrorMsg:error, failedAddUploads:[...this.state.failedAddUploads, image]})
        }
    };

    completeCallBack = () => {
        this.setState({uploading:false})
        this.getAdditionalImages()
    };


    preloadImages = (dropzone,imageData) => {
        if (imageData) {

            for (let i = 0; i < imageData.length; i++){
                if(imageData[i].image_type == this.props.roomClientId){
            const name = imageData[i].id
            const file = {url: imageData[i].file?imageData[i].file:unavailable, name: name, size: 1000000, id: name};
            const imageUrl = imageData[i].file;

            file['serverId'] = name;
            file['accepted'] = true;
            file['status'] = 'success';
            file['upload'] = {
                progress: 100,
                total: 100000,
                bytesSent: 100000
            };
            dropzone.files.push(file);
            this.state.attachments.push(file)
            this.setState({preLoaded:true});
            dropzone.emit("addedfile", file);
            dropzone.emit("thumbnail", file, imageUrl);
                dropzone.emit("complete", file);
            }
        }
        }
    };

    removingFile = (file) => {
        let attachments = this.state.attachments;
        if (attachments.indexOf(file) !== -1) {
            attachments.splice(attachments.indexOf(file), 1);
        }
        if (file.id) { deleteAdditionalImage({image_id:file.id}) }
        return attachments;
    };
    render() {
        
        let dropZone = null;
        const componentConfig = {postUrl: 'no-url'};

        let djsConfig = {
            autoProcessQueue: false,
            addRemoveLinks: true,
            acceptedFiles: "image/jpeg, image/png, image/gif",
        };
        const eventHandlers = {
            init: (dropzone) => {
                dropZone = dropzone;
                dropZone.autoDiscover = false;
                this.preloadImages(dropzone, this.state.additional_images);
            },
            addedfile: (file) => {
                if(file.type.startsWith("image/")){
                  this.setState({attachments:[...this.state.attachments,file]})
                    this.setState({imageError:false})
                }
                else {
                    this.setState({imageError:true})
                }
            },

            removedfile: (file) => {
                this.removingFile(file)                   
            }
        };
        
       
        

        
        const reportKeys = this.props.reportDetails ? this.props.reportDetails.keys : [];
        const ciImages = this.props.reportDetails['ci_keys_image'];
        const coImages = this.props.reportDetails['co_keys_image'];
        const inspectionType = this.props.reportDetails['inspection_type'];

        return             <div style={{marginTop:"20px",textAlign:"center"}}>

                            {!this.state.show && <Button icon onClick={()=>{this.getAdditionalImages()}}><Icon name="camera"></Icon> Show Additional {this.props.group ? "Group" : "Room"} Photos Uploader</Button>}
                            {this.state.show && <React.Fragment>
                                 <Header style={{marginBottom:"20px"}} textAlign="left">Additional {this.props.group ? "Group" : "Room"} Photos{this.state.show && <Button className="pull-right" negative compact onClick={()=>{this.setState({show:false})}}>Close</Button>}{this.state.attachments.filter(att => att["status"] != "success").length > 0 && !this.state.uploading && <Button className="pull-right"  compact onClick={()=>{this.uploadAdditionalRoomImages()}} 
                                 icon="warning">Upload Images  ({this.state.attachments.filter(att => att["status"] != "success").length}) </Button>}
                                {this.state.failedAddUploads.filter(att => att["status"] != "success").length > 0 && !this.state.uploading && <Button className="pull-right"  compact onClick={()=>{this.retryImageUpload()}} 
                                 icon="warning">Retry Failed Uploads ({this.state.failedAddUploads.length})</Button>}  </Header>   
                                 {this.state.loading && <Loader contain={true}></Loader>}  
                                {this.state.uploading && <Button.Group><Button loading></Button><Button>Uploading Image {this.state.imgNumber + 1} of {this.state.totalImgNumber}</Button></Button.Group>}                  
                        {!this.state.loading && !this.state.uploading && <React.Fragment>
                            <DropzoneComponent config={componentConfig} style={{ minHeight: 250 }}
                eventHandlers={eventHandlers} djsConfig={djsConfig}/></React.Fragment> }
                                </React.Fragment>}
                                </div>        
    }
}

export default ReportContainer(AdditionalRoomPhotos);


// WEBPACK FOOTER //
// ./src/views/report/additional_room_photos.js